import $ from 'jquery';
import Globals from '../helpers/Globals';

const { $body } = Globals;

const Header = {
    init() {
        $body.on('click', '.js-menu-toggle', () => this.handleMenu());
        $body.on('click', '.js-lang-toggle', () => this.handleLang());
    },

    handleMenu() {
        $body.toggleClass('menu-open');
    },

    handleLang() {
        $('.js-lang-parent').toggleClass('active');
    },
};

export default Header;
